export default __webpack_public_path__ + "assets/bc6dfe321ef371205c57640edb5609f6.svg";